import React from "react";
import { useParams, useHistory } from "react-router-dom";

import { BrowserTemplate as BrowserTemplateForSP } from "../../../../template/service-provider/default-template";
import { BrowserTemplate as BrowserTemplateForTenant } from "../../../../template/base-template";
import { PdfOutputConfigurationContainer } from "../../../../organisms/smart-apply/procedure-detail/pdf-output-configuration/container";
import { ProcedureEntity } from "../../../../../application/domain/procedures/procedure-entity";
import { useAuthContextV2 } from "../../../../../auth-state";
import { PdfOutputConfigurationService } from "../../../../../application/service/smart-apply/procedure-detail/pdf-output-configuration-service";

export const PdfOutputConfiguration: React.FC = () => {
  const history = useHistory();
  const { procedureId } = useParams<{ procedureId: string }>();
  const [procedure, setProcedure] = React.useState<ProcedureEntity>();
  const { auth } = useAuthContextV2();
  React.useEffect(() => {
    (async () => {
      const proc =
        await PdfOutputConfigurationService.fetchProcedureById(procedureId);
      if (proc) {
        setProcedure(proc);
      }
    })();
  }, [procedureId, setProcedure]);
  const TemplateComponent = auth.isServiceProviderAccount()
    ? BrowserTemplateForSP
    : BrowserTemplateForTenant;
  return (
    <TemplateComponent title="スマート申請">
      <div className="wrapper">
        {!!procedure && !!auth && (
          <PdfOutputConfigurationContainer
            procedure={procedure}
            auth={auth}
            history={history}
          />
        )}
      </div>
    </TemplateComponent>
  );
};
